import './Footer.css'

export interface IFooterInfoSection {
    title: string
    items: Array<IFooterInfoSectionItem>
}

export interface IFooterInfoSectionItem {
    title: string
    link: string
    target?: string
}

export interface IFooterInfoSectionProps {
    section: IFooterInfoSection
    mobile: boolean
}

export default function FooterInfoSection(props: IFooterInfoSectionProps) {
    let items: Array<JSX.Element> = []
    props.section.items.forEach((item, index) => {
        items.push(<a key={item.title} target={item.target ?? "_blank"} href={item.link} className="Footer_info_section_item">{item.title}</a>);
        if (index !== props.section.items.length - 1) {
            items.push(<div className="Footer_info_section_separator"/>)
        }
    })
    if (props.mobile) {
        return <div className="Footer_info_section_mobile">
            <div className="Footer_info_section_title">{props.section.title}</div>
            <div className="Footer_info_section_separator"/>
            {items}
        </div>
    } else {
        return <div className="Footer_info_section">
            <div className="Footer_info_section_title">{props.section.title}</div>
            <div className="Footer_info_section_separator"/>
            {items}
        </div>
    }
}